import {
    apiAxios
} from '../axios'

import Europess from '../wangZhi'
let Europe = Europess + '/client/'
let comm_api = Europess + '/api'
export default {
    // 获取收款账号
    getBankAccount: data => apiAxios('post', Europe + "getBankAccount", data),

}